<template>
	<v-container fluid class="d-flex flex-column flex-content-justify-center" style="color: #9e9e9e; overflow: hidden;">
		<div class="mb-4 mx-auto">
			<v-card style="border-radius: 100%; padding: 0 20px 10px 20px; background: #fff; font-size: 4rem; width: fit-content;">
				<v-icon x-large style="color: #9e9e9e; font-size: 4rem;">
					schedule
				</v-icon>
			</v-card>
		</div>
		<span class="text-center" style="font-size: 24px; font-weight: 500;">{{ title }}</span>
		<p class="text-center" style="font-size: 15px;">{{ description }}</p>
  </v-container>
</template>

<script>

export default {
	name: 'EmptyState',
	props: ['title', 'description'],
	data () {
		return {
		}
	}
}
</script>